<template>
  <div>
    <div
      class="form-detail"
      v-if="
        dataContract &&
        dataContract.historyInvoiceLogRes &&
        dataContract.historyInvoiceLogRes.length > 0
      "
    >
      <h1>Lịch sử điều chỉnh thông tin nhận hoá đơn</h1>
      <div class="table-responsive">
        <table class="table table-hover table-bordered">
          <thead class="thead-light">
            <tr>
              <th scope="col" class="text-left">Thời gian</th>
              <th scope="col" class="text-left">Người thao tác</th>
              <th scope="col" class="text-left">Thao tác</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in dataContract.historyInvoiceLogRes" :key="index">
            <tr class="table-row">
              <td align="left">{{ item.createdTime | formatDate('HH:mm, DD/MM/YYYY') }} <br /></td>
              <td align="left">{{ item.creator.name + ' - ' + item.creator.email }} <br /></td>
              <td align="left">
                <span v-if="item.action">
                  {{ item.action | transformData(actionMap) }}
                </span>
                <span v-else>{{ item.action || 'Không xác định' }}</span>
                <a
                  v-if="item.action === 'UPDATE'"
                  @click.prevent="showDetail(item)"
                  class="text-primary cursor"
                  >(chi tiết)</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['dataContract'],
    data() {
      return {
        actionMap: [
          { id: 'UPDATE', text: 'Sửa thông tin nhận hoá đơn' },
          { id: 'CONFIRMED', text: 'Xác thực thông tin nhận hoá đơn' },
          { id: 'UNCONFIRMED', text: 'Bỏ xác thực thông tin nhận hoá đơn' },
        ],
      }
    },
    methods: {
      showDetail(item) {
        this.$router.push({ name: 'historyActionDetails', params: { historyData: item } })
      },
    },
  }
</script>

<style></style>
